// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Note: These values are safe to expose - apiKey is a public identifier, not a secret
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyClDXVAo3Mgitt6ochqa_e5EzLA0hNzci4",
  authDomain: "nur-al-huda.firebaseapp.com",
  projectId: "nur-al-huda",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "nur-al-huda.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "452293581520",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:452293581520:web:9205e6492b6a4866ae9cd5",
  measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID || "G-V0JH94K8WC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

// Initialize Analytics (only in browser environment, not during SSR)
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics initialization failed:', error);
  }
}

export { analytics };